// Central SEO configuration and JSON-LD structured data builders for Crimson Inks.
// Canonical domain — change here if the primary domain changes (e.g. to www).
export const SITE_URL = "https://crimsoninks.in";
export const SITE_NAME = "Crimson Inks";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/crimson-logo-with-name.png`;

export const PHONE = "+91-7706994400";
export const EMAIL = "Crimson.inks7475@gmail.com";

// Organization @id used to cross-reference structured data nodes.
const ORG_ID = `${SITE_URL}/#organization`;

export const organizationSchema = {
  "@type": ["Organization", "Manufacturer"],
  "@id": ORG_ID,
  name: "Crimson Inks Private Limited",
  legalName: "Crimson Inks Private Limited",
  alternateName: "Crimson Inks",
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  slogan: "Adding colors to life",
  description:
    "Crimson Inks Private Limited is an ISO 9001:2015 certified manufacturer of UV and LED curable inks and coatings for gravure, screen, offset and flexo printing, based in Kanpur, Uttar Pradesh, India.",
  foundingDate: "2000",
  email: EMAIL,
  telephone: PHONE,
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "G-12-13, Bajrang Bali Udhyogic Asthan, Logistics Park Panki, Raniganj Industrial Area, Site 4, Panki",
    addressLocality: "Kanpur",
    addressRegion: "Uttar Pradesh",
    postalCode: "208020",
    addressCountry: "IN",
  },
  founder: [
    { "@type": "Person", name: "Chirag Jain" },
    { "@type": "Person", name: "Prateek Jain" },
  ],
  sameAs: ["https://www.instagram.com/crimson_inks_/"],
  areaServed: "IN",
  knowsAbout: [
    "UV curable coatings",
    "LED curable coatings",
    "gravure printing inks",
    "screen printing inks",
    "offset printing inks",
    "flexo printing inks",
    "security inks",
    "overprint varnish",
  ],
};

export const orgReference = { "@id": ORG_ID };

// Build a Breadcrumb JSON-LD node from [{name, path}] items.
export const buildBreadcrumb = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

// Build an FAQPage JSON-LD node from [{question, answer}].
export const buildFaq = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});
